import { render, staticRenderFns } from "./TheSkeletonLoader.vue?vue&type=template&id=fda4592e&scoped=true&"
import script from "./TheSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./TheSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./TheSkeletonLoader.vue?vue&type=style&index=0&id=fda4592e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda4592e",
  null
  
)

export default component.exports